/* eslint-disable max-len */
import React from "react";

interface SVGRProps {
  title?: string;
  titleId?: string;
}

const BackArrow = ({
    title,
    titleId = "tm-icon-BackArrow",
    ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 18"
        aria-hidden={!title}
        height="1em"
        width="1em"
        role={title ? "img" : ""}
        aria-labelledby={titleId}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            fill="#666"
            fillRule="evenodd"
            d="M.262 9.678a.896.896 0 010-1.267L8.464.361a1.317 1.317 0 011.812 0 1.25 1.25 0 010 1.791 583.434 583.434 0 01-5.78 5.626c-.156.149 4.585.149 14.223 0 .854 0 1.281.422 1.281 1.267 0 .844-.427 1.266-1.281 1.266H4.496l5.87 5.537a1.25 1.25 0 010 1.791 1.317 1.317 0 01-1.812 0L.262 9.678z"
        />
    </svg>
);

export default BackArrow;
